<template>
  <b-overlay :show="busy" rounded="sm">
    <b-card class="standardpage tiles">
      <b-card-header>
        <i :class="icon" class="mr-1"></i>
        <!-- <CIcon :name="icon" /> -->
        {{ title }}
        <div class="card-header-actions">
          <b-button size="sm" variant="outline-primary" class="card-header-action mr-1" @click="layout_refresh()"
            :disabled="layout_edit">
            <i class="fa fa-refresh"></i>
          </b-button>

          <b-button size="sm" variant="outline-primary" class="card-header-action" :disabled="layout_edit"
            v-b-toggle.addtile>
            <i class="fa fa-plus-square"></i>
          </b-button>
        </div>
      </b-card-header>

      <b-card-body class="px-0">
        <b-row class="px-3">
          <b-col>
            <div id="refresh">
              <div v-if="window.width > 768">
                <span class="mr-2">Auto refresh:</span>
                <b-button v-if="refresh_at > 0" id="refresh_popover-id" size="sm" variant="outline-primary" ref="button"
                  style="width: 100px">{{ refresh_at }} minute(s)</b-button>
                <b-button v-if="refresh_at == 0" id="refresh_popover-id" size="sm" variant="outline-primary" ref="button"
                  class="ml-2" style="width: 100px">Off</b-button>
              </div>
              <div v-else>
                <b-row>
                  <b-col cols="12" md="6">Auto refresh:</b-col>
                  <b-col>
                    <b-button v-if="refresh_at > 0" id="refresh_popover-id" size="sm" variant="outline-primary"
                      ref="button" style="width: 100px">{{ refresh_at }} minute(s)</b-button>
                    <b-button v-if="refresh_at == 0" id="refresh_popover-id" size="sm" variant="outline-primary"
                      ref="button" class="ml-2" style="width: 100px">Off</b-button>
                  </b-col>
                </b-row>
              </div>
            </div>
            <b-popover target="refresh_popover-id" :show.sync="refresh_popover" triggers="click" placement="bottom"
              container="refresh" ref="popover">
              <div>
                <b-form-radio-group class="mt-2 mb-2" name="Auto Refresh Every" v-model="refresh_at" :options="[
                  { text: 'Off', value: 0 },
                  { text: '1 min', value: 1 },
                  { text: '5 min', value: 5 },
                  { text: '10 min', value: 10 },
                ]" stacked></b-form-radio-group>

                <b-button @click="refresh_popover = false" size="sm" variant="outline-primary" class="ml-2">OK</b-button>
              </div>
            </b-popover>
          </b-col>
          <b-col align-self="end" class="text-right">
            <div v-if="window.width > 768">
              <span class="mr-2">Last updated:</span>
              <span class="text-primary">{{ refresh_timeago }}</span>
            </div>
            <div v-else>
              <b-row>
                <b-col class="text-right" cols="12" md="6">Last updated:</b-col>
                <b-col>
                  <span class="text-primary">{{ refresh_timeago }}</span>
                </b-col>
              </b-row>
            </div>
          </b-col>
        </b-row>
        <b-row class="px-3 mt-4">
          <b-button-group class="ml-3">
            <b-row no-gutters>
              <b-col cols="auto">
                <b-button squared size="sm" :title="title + ' tiles'" :variant="toolbar_variant"
                  :pressed="selectedComponent == null" @click="selectedComponent = null"><i
                    class="fa fa-home pr-3"></i>Home</b-button></b-col>


              <b-col cols="auto" v-if="permissionvalid('tool.filemanager')">
                <b-button squared size="sm" :variant="toolbar_variant" :pressed="selectedComponent == 'FileManager'"
                  @click="selectedComponent = 'FileManager'">
                  <i class="fa fa-sitemap pr-3"></i>File Manager
                </b-button></b-col>

                
              <b-col cols="auto" v-if="permissionvalid('cms.view')">
                <b-button squared size="sm" :variant="toolbar_variant" :pressed="selectedComponent == 'CMS'"
                  @click="selectedComponent = 'CMS'">
                  <i class="fa fa-list pr-3"></i>CMS
                </b-button></b-col>

              <b-col cols="auto">
                <b-dropdown size="sm" left :variant="toolbar_variant">
                  <template slot="button-content">
                    <i class="fa fa-database mr-1"></i>
                    Old Database
                  </template>
                  <!-- <b-dropdown-item class="menuitem" v-if="permissionvalid('tickets.view')"
                    :active="selectedComponent == 'Tickets' ? true : false" @click="selectedComponent = 'Tickets'"><i
                      class="fa fa-ticket"></i>Tickets</b-dropdown-item> -->
                  <!-- <b-dropdown-item class="menuitem" v-if="permissionvalid('flights.view')"
                    :active="selectedComponent == 'Vipasp' ? true : false" @click="selectedComponent = 'Vipasp'"><i
                      class="fa fa-plane"></i>Flights</b-dropdown-item> -->
                  <!-- <b-dropdown-item class="menuitem" v-if="permissionvalid('charters.view')"
                    :active="selectedComponent == 'Charters' ? true : false" @click="selectedComponent = 'Charters'"><i
                      class="fa fa-fighter-jet"></i>Charters</b-dropdown-item> -->

                  <b-dropdown-item>
                    <i class="fa fa-ticket"></i>
                    Tickets Management
                    <!-- <b-dropdown-item class="menuitem" v-if="permissionvalid('tickets.costcentre')"
                      :active="selectedComponent == 'TicketsCC' ? true : false"
                      @click="selectedComponent = 'TicketsCC'"><i class="fa fa-ticket text-danger"></i>Ticket Cost
                      Centre</b-dropdown-item> -->

                    <!-- <b-dropdown-item v-if="permissionvalid('tickets.validation')" class="menuitem" :active="selectedComponent == 'TicketsValid' ? true : false
                      " @click="selectedComponent = 'TicketsValid'"><i class="fa fa-ticket text-danger"></i>Ticket
                      Validation</b-dropdown-item> -->
                    <!-- <b-dropdown-item class="menuitem" v-if="permissionvalid('tickets.void')" :active="selectedComponent == 'TicketsVoid' ? true : false
                      " @click="selectedComponent = 'TicketsVoid'"><i class="fa fa-ticket text-danger"></i>Ticket
                      Void</b-dropdown-item> -->

                  </b-dropdown-item>
                  <b-dropdown-item>
                    <i class="fa fa-leanpub"></i>
                    Reports
                    <b-dropdown-item>
                      <i class="fa fa-circle-o"></i>
                      Group Bookings

                      <b-dropdown-item class="menuitem" :pressed="selectedComponent == 'Report'" @click="
                        runreport({
                          label: 'Contracted Seat Summary',
                          id: 'report_contractedseatsummary',
                        })
                        "><i class="fa fa-leanpub"></i>Contracted Seat
                        Summary</b-dropdown-item>
                      <b-dropdown-item class="menuitem" :pressed="selectedComponent == 'Report'" @click="
                        runreport({
                          label: 'Flight Bookings',
                          id: 'report_flightbookings',
                        })
                        "><i class="fa fa-leanpub"></i>Flight
                        Bookings</b-dropdown-item>

                      <b-dropdown-item class="menuitem" :pressed="selectedComponent == 'Report'" @click="
                        runreport({
                          label: 'Flight Bookings Class',
                          id: 'report_flightbookings_class',
                        })
                        "><i class="fa fa-leanpub"></i>Flight Bookings
                        Class</b-dropdown-item>

                      <b-dropdown-item class="menuitem" :pressed="selectedComponent == 'Report'" @click="
                        runreport({
                          label: 'Flight Inventory Totals',
                          id: 'report_flighttotals',
                        })
                        "><i class="fa fa-leanpub"></i>Flight Inventory
                        Totals</b-dropdown-item>

                      <b-dropdown-item class="menuitem" :pressed="selectedComponent == 'Report'" @click="
                        runreport({
                          label: 'Passenger',
                          id: 'report_passenger',
                        })
                        "><i class="fa fa-leanpub"></i>Passenger</b-dropdown-item>

                    </b-dropdown-item>
                    <b-dropdown-item>
                      <i class="fa fa-circle-o"></i>
                      Tickets
                      <b-dropdown-item class="menuitem" :pressed="selectedComponent == 'Report'" @click="
                        runreport({
                          label: 'Tickets Not Invoiced',
                          id: 'report_ticketsnotinvoiced_pg',
                        })
                        "><i class="fa fa-leanpub"></i>Tickets Not
                        Invoiced</b-dropdown-item>
                      <b-dropdown-item class="menuitem" :pressed="selectedComponent == 'Report'" @click="
                        runreport({
                          label: 'Tickets Void',
                          id: 'report_ticketsvoid',
                        })
                        "><i class="fa fa-leanpub"></i>Tickets
                        Void</b-dropdown-item>

                      <!-- <b-dropdown-item class="menuitem" :pressed="selectedComponent == 'Report'" @click="
                        runreport({
                          label: 'Tickets VIK',
                          id: 'report_ticketsvik',
                        })
                      "><i class="fa fa-leanpub"></i>Tickets VIK</b-dropdown-item> -->
                      <b-dropdown-item class="menuitem" :pressed="selectedComponent == 'Report'" @click="
                        runreport({
                          label: 'Ticket Table (saracs_live)',
                          id: 'report_tickettable',
                        })
                        "><i class="fa fa-leanpub"></i>Ticket Table
                        (saracs_live)</b-dropdown-item>
                    </b-dropdown-item>
                  </b-dropdown-item>
                  <b-dropdown-item>

                  </b-dropdown-item>
                </b-dropdown>
              </b-col>

              <b-col cols="auto">
                <b-dropdown size="sm" left :variant="toolbar_variant">
                  <template slot="button-content">
                    <i class="fa fa-cogs mr-1"></i>
                    Carbon Setup
                  </template>
                  <!-- v-if="permissionvalid('setup.carbonnonaircodes')" -->
                  <b-dropdown-item class="menuitem" v-if="permissionvalid('systems.development')"
                    :pressed="selectedComponent == 'CarbonNonair'" @click="selectedComponent = 'CarbonNonair'"><i
                      class="fa fa-globe mr-1"></i>Carbon Non-Air
                    Data</b-dropdown-item>
                  <b-dropdown-item v-if="permissionvalid('setup.clientitineararies')" class="menuitem"
                    :pressed="selectedComponent == 'Itineraries'" @click="selectedComponent = 'Itineraries'"><i
                      class="fa fa-suitcase mr-1"></i>Client
                    Itineraries</b-dropdown-item>
                  <b-dropdown-item v-if="permissionvalid('setup.clientemails')" class="menuitem"
                    :pressed="selectedComponent == 'ClientEmails'" @click="selectedComponent = 'ClientEmails'"><i
                      class="fa fa-envelope mr-1"></i>Client
                    Emails</b-dropdown-item>
                </b-dropdown>
              </b-col>


              <b-col cols="auto" v-if="permissionvalid('systems.development')">
                <b-dropdown size="sm" left :variant="toolbar_variant">
                  <template slot="button-content">
                    <i class="fa fa-wrench mr-1"></i>
                    Development
                  </template>
                  <b-dropdown-item class="menuitem" :pressed="selectedComponent == 'Datepickers'"
                    @click="selectedComponent = 'Datepickers'"><i class="fa fa-calendar"></i>Datepickers</b-dropdown-item>
                  <b-dropdown-item class="menuitem" :pressed="selectedComponent == 'Multigrid'"
                    @click="selectedComponent = 'Multigrid'"><i class="fa fa-table"></i>Multigrid</b-dropdown-item>
                  <b-dropdown-item class="menuitem" :pressed="selectedComponent == 'Wizards'"
                    @click="selectedComponent = 'Wizards'"><i class="fa fa-magic"></i>Wizards</b-dropdown-item>
                  <b-dropdown-item class="menuitem" :pressed="selectedComponent == 'TasksViewer2'"
                    @click="selectedComponent = 'TasksViewer2'"><i class="fa fa-magic"></i>TasksViewer2</b-dropdown-item>


                  <!-- <b-dropdown-item class="menuitem" :pressed="selectedComponent == 'TasksScheduler2'"
                    @click="selectedComponent = 'TasksScheduler2'"><i
                      class="fa fa-clock-o"></i>TasksScheduler2</b-dropdown-item> -->
                  <b-dropdown-item class="menuitem" :pressed="selectedComponent == 'Slidegroup'"
                    @click="selectedComponent = 'Slidegroup'"><i class="fa fa-magic"></i>Slidegroup</b-dropdown-item>

                  <!-- <b-dropdown-item class="menuitem" :pressed="selectedComponent == 'SLStatements2' ? true : false"
                    @click="selectedComponent = 'SLStatements2'">
                    <i class="fa fa-gbp"></i>Statements2</b-dropdown-item> -->

                </b-dropdown>
              </b-col>

            </b-row>
          </b-button-group>
        </b-row>
        <div v-if="selectedComponent == null" class="dashboard_layout mt-4 ml-3">
          <b-row no-gutters :style="layout_edit ? 'background-color:rgba(225, 225, 225, 0.1)' : ''
            ">
            <b-col :cols="item.cols" :md="item.md" :lg="item.lg" v-for="(item, index) in layout_grid" :key="index" no-body
              class="pr-3">
              <b-card class="ml-0" no-body :border-variant="tile_selected == index ? 'secondary' : null"
                style="border-radius: 0" @mouseover="!tile_settings ? (tile_selected = index) : null">
                <div class="popover-actions" :id="'actions-container-' + index.toString()">
                  <b-button v-show="tile_selected == index" variant="link" size="sm" title="Actions" squared
                    :id="'popover-target-' + index.toString()" class="float-right p-0">
                    <i class="fa fa-ellipsis-h text-primary"></i>
                  </b-button>
                </div>
                <b-popover :container="'actions-container-' + index.toString()"
                  :target="'popover-target-' + index.toString()" triggers="hover" placement="leftbottom">
                  <div>
                    <b-nav vertical>
                      <section v-for="(action, index) in defaultOptions.layout_grid[
                        index
                      ].options.actions" :key="index">
                        <b-nav-item v-if="!action.divider" :title="action.label"
                          @click.stop="invoke_action(action, index)">
                          <b-row class="px-2">
                            <b-col class="px-0">
                              <span class="text-normal">{{
                                action.label
                              }}</span>
                            </b-col>
                            <b-col cols="1">
                              <i :class="action.icon" class="text-primary"></i>
                            </b-col>
                          </b-row>
                        </b-nav-item>
                        <div class="divider" v-if="action.divider"></div>
                      </section>
                    </b-nav>
                  </div>
                </b-popover>
                <component :is="item.name" :tile="item" :refresh="refresh" @refreshed="refresh = false"></component>
              </b-card>
            </b-col>
          </b-row>
        </div>
        <div class="px-3 mt-3">
          <keep-alive>
            <component :is="selectedComponent" :search="search" :refresh="refresh" @refreshed="refresh = false" />
          </keep-alive>
        </div>
      </b-card-body>
    </b-card>
    <TileAdd />
    <TileSettings v-if="tile_selected || tile_selected == 0" :tile="defaultOptions.layout_grid[tile_selected]
      ? defaultOptions.layout_grid[tile_selected]
      : { name: 'Empty Settings', settings: [] }
      " @apply="saveTile" @cancel="tile_settings = false" />
  </b-overlay>
</template>

<script>
import { mapGetters } from "vuex";
import gql from "graphql-tag";

import FileManager from "./Systems/Filemanager";
import Multigrid from "./Systems/Multigrid";
import Datepickers from "./Systems/Datepickers";
import Import from "./Systems/Import";
import Wizards from "./Systems/Wizards";
import Slidegroup from "./Systems/Slidegroup";
import CMS from "./Systems/CMS";

import TasksViewer2 from "../TasksViewer2";
// import SLStatements2 from "../Apps/Accounts/SLStatements2";

// import Tickets from "./Flights/Tickets";
//import TicketsCC from "./Flights/TicketsCC";
//import TicketsInvoice from "./Flights/TicketsInvoice";
//import TicketsValid from "./Flights/TicketsValid";
//import TicketsVoid from "./Flights/TicketsVoid";
// import FlightsEvents from "./Flights/FlightsEvents";
//import Charters from "./Flights/Charters";
//import Vipasp from "./Flights/Vipasp";

import Itineraries from "./Partners/Itineraries";
import ClientEmails from "./Partners/ClientEmails";
import CarbonNonair from "./Partners/HotelRoomlists";

import TickZhold from "@/pages/private/Tiles/TickZhold";

export default {
  name: "General",
  components: {
    FileManager,
    Multigrid,
    Datepickers,
    Import,
    Wizards,
    Slidegroup,
    TasksViewer2,
    // SLStatements2,
    TickZhold,
    //Tickets,
    //TicketsCC,
    //TicketsInvoice,
    //TicketsValid,
    //TicketsVoid,
    // FlightsEvents,
    // Charters,
    //Vipasp,
    CMS,
    Itineraries,
    ClientEmails,
    CarbonNonair
  },
  async activated() {
    console.log("dashboard is activated");
    this.layout_refresh();
  },
  deactivated() {
    console.log("dashboard is deactivated");
    clearInterval(this.timer_time);
    clearInterval(this.timer_refresh);
  },
  data() {
    return {
      title: "Systems",
      icon: "fa fa-heartbeat",
      toolbar_variant: "outline-primary",
      busy: false,
      refresh: false,
      refresh_at: 5,
      refresh_time: new Date(),
      refresh_timeago: "",
      refresh_popover: false,
      layout_grid: [],
      layout_edit: false,
      tile_selected: null,
      tile_settings: false,
      timer_time: null,
      timer_refresh: null,
      defaultOptions: {
        layout_grid: [
          {
            moved: false,
            id: "0f5085d8-b594-40f0-8e0f-642042af2ee2",
            name: "SabrePNRStatus",
            cols: 12,
            md: 6,
            lg: 6,
            settings: [
              {
                key: "type",
                label: "Chart Type",
                type: "radio-group",
                buttons: true,
                "button-variant": "outline-primary",
                values: [{ value: "table", text: "Table" }],
                value: "table",
              },
              {
                key: "fileid",
                label: "File Id",
                type: "radio-group",
                buttons: true,
                "button-variant": "outline-primary",
                values: [{ value: "navitas_log", text: "navitas_log" }],
                value: "navitas_log",
              },
              {
                key: "title",
                label: "Title",
                type: "radio-group",
                buttons: true,
                "button-variant": "outline-primary",
                values: [
                  { value: true, text: "On" },
                  { value: false, text: "Off" },
                ],
                value: true,
                tab: "Annotate",
              },
              {
                key: "titletext",
                label: "Title Text",
                type: "text",
                value: "ETRPStatus",
                tab: "Annotate",
              },
              {
                key: "legend",
                label: "Legend",
                type: "radio-group",
                buttons: true,
                "button-variant": "outline-primary",
                values: [
                  { value: true, text: "On" },
                  { value: false, text: "Off" },
                ],
                value: false,
                tab: "Annotate",
              },
              {
                key: "legendposition",
                label: "Legend Position",
                type: "radio-group",
                buttons: true,
                "button-variant": "outline-primary",
                values: [
                  { value: "top", text: "Top" },
                  { value: "bottom", text: "Bottom" },
                  { value: "left", text: "Left" },
                  { value: "right", text: "Right" },
                ],
                value: "bottom",
                tab: "Annotate",
              },
              {
                key: "datalabels",
                label: "Data Labels",
                type: "radio-group",
                buttons: true,
                "button-variant": "outline-primary",
                values: [
                  { value: true, text: "On" },
                  { value: false, text: "Off" },
                ],
                value: false,
                tab: "Annotate",
              },

              {
                key: "titlefontnamesize",
                label: "",
                label_type: "Font Type",
                label_size: "Font Size",
                type: "fontsize",
                values_type: [
                  { value: "Arial", text: "Arial" },
                  { value: "Helvetica Neue", text: "Helvetica Neue" },
                ],
                values_size: [
                  { value: "10", text: "10" },
                  { value: "12", text: "12" },
                  { value: "14", text: "14" },
                ],
                tab: "Fonts",
              },
            ],
            options: {
              actions: [
                {
                  key: "settings",
                  label: "Settings",
                  icon: "fa fa fa-cog text-primary",
                },
                { divider: true },
                { key: "small", label: "Small", icon: "fa fa-th text-primary" },
                {
                  key: "large",
                  label: "Large",
                  icon: "fa fa-square text-primary",
                },
                { divider: true },
                {
                  key: "delete",
                  label: "Delete",
                  icon: "fa fa-trash text-danger",
                },
              ],
            },
          },
          {
            moved: false,
            id: "0f6085d8-b594-40f0-8e0f-642042af2ee2",
            name: "TickNIChart",
            cols: 12,
            md: 6,
            lg: 6,
            settings: [
              {
                key: "type",
                label: "Chart Type",
                type: "radio-group",
                buttons: true,
                "button-variant": "outline-primary",
                values: [{ value: "horizontalbar", text: "Horizontal Bar" }],
                value: "horizontalbar",
              },
              {
                key: "server",
                label: "Server",
                type: "radio-group",
                buttons: true,
                "button-variant": "outline-primary",
                values: [{ value: "LIVE", text: "LIVE" }],
                value: "LIVE",
              },
              {
                key: "title",
                label: "Title",
                type: "radio-group",
                buttons: true,
                "button-variant": "outline-primary",
                values: [
                  { value: true, text: "On" },
                  { value: false, text: "Off" },
                ],
                value: true,
                tab: "Annotate",
              },
              {
                key: "titletext",
                label: "Title Text",
                type: "text",
                value: "ETRPStatus",
                tab: "Annotate",
              },
              {
                key: "legend",
                label: "Legend",
                type: "radio-group",
                buttons: true,
                "button-variant": "outline-primary",
                values: [
                  { value: true, text: "On" },
                  { value: false, text: "Off" },
                ],
                value: false,
                tab: "Annotate",
              },
              {
                key: "legendposition",
                label: "Legend Position",
                type: "radio-group",
                buttons: true,
                "button-variant": "outline-primary",
                values: [
                  { value: "top", text: "Top" },
                  { value: "bottom", text: "Bottom" },
                  { value: "left", text: "Left" },
                  { value: "right", text: "Right" },
                ],
                value: "bottom",
                tab: "Annotate",
              },
              {
                key: "datalabels",
                label: "Data Labels",
                type: "radio-group",
                buttons: true,
                "button-variant": "outline-primary",
                values: [
                  { value: true, text: "On" },
                  { value: false, text: "Off" },
                ],
                value: false,
                tab: "Annotate",
              },

              {
                key: "titlefontnamesize",
                label: "",
                label_type: "Font Type",
                label_size: "Font Size",
                type: "fontsize",
                values_type: [
                  { value: "Arial", text: "Arial" },
                  { value: "Helvetica Neue", text: "Helvetica Neue" },
                ],
                values_size: [
                  { value: "10", text: "10" },
                  { value: "12", text: "12" },
                  { value: "14", text: "14" },
                ],
                tab: "Fonts",
              },
            ],
            options: {
              actions: [
                {
                  key: "settings",
                  label: "Settings",
                  icon: "fa fa fa-cog text-primary",
                },
                { divider: true },
                { key: "small", label: "Small", icon: "fa fa-th text-primary" },
                {
                  key: "large",
                  label: "Large",
                  icon: "fa fa-square text-primary",
                },
                { divider: true },
                {
                  key: "delete",
                  label: "Delete",
                  icon: "fa fa-trash text-danger",
                },
              ],
            },
          },
          // {
          //   moved: false,
          //   id: "0f6085d8-b594-40f0-8e0f-642042af2ee2",
          //   name: "OrderChart",
          //   cols: 12,
          //   md: 6,
          //   lg: 6,
          //   settings: [
          //     {
          //       key: "type",
          //       label: "Chart Type",
          //       type: "radio-group",
          //       buttons: true,
          //       "button-variant": "outline-primary",
          //       values: [{ value: "horizontalbar", text: "Horizontal Bar" }],
          //       value: "horizontalbar",
          //     },
          //     {
          //       key: "server",
          //       label: "Server",
          //       type: "radio-group",
          //       buttons: true,
          //       "button-variant": "outline-primary",
          //       values: [{ value: "LIVE", text: "LIVE" }],
          //       value: "LIVE",
          //     },
          //     {
          //       key: "title",
          //       label: "Title",
          //       type: "radio-group",
          //       buttons: true,
          //       "button-variant": "outline-primary",
          //       values: [
          //         { value: true, text: "On" },
          //         { value: false, text: "Off" },
          //       ],
          //       value: true,
          //       tab: "Annotate",
          //     },
          //     {
          //       key: "titletext",
          //       label: "Title Text",
          //       type: "text",
          //       value: "ETRPStatus",
          //       tab: "Annotate",
          //     },
          //     {
          //       key: "legend",
          //       label: "Legend",
          //       type: "radio-group",
          //       buttons: true,
          //       "button-variant": "outline-primary",
          //       values: [
          //         { value: true, text: "On" },
          //         { value: false, text: "Off" },
          //       ],
          //       value: false,
          //       tab: "Annotate",
          //     },
          //     {
          //       key: "legendposition",
          //       label: "Legend Position",
          //       type: "radio-group",
          //       buttons: true,
          //       "button-variant": "outline-primary",
          //       values: [
          //         { value: "top", text: "Top" },
          //         { value: "bottom", text: "Bottom" },
          //         { value: "left", text: "Left" },
          //         { value: "right", text: "Right" },
          //       ],
          //       value: "bottom",
          //       tab: "Annotate",
          //     },
          //     {
          //       key: "datalabels",
          //       label: "Data Labels",
          //       type: "radio-group",
          //       buttons: true,
          //       "button-variant": "outline-primary",
          //       values: [
          //         { value: true, text: "On" },
          //         { value: false, text: "Off" },
          //       ],
          //       value: false,
          //       tab: "Annotate",
          //     },

          //     {
          //       key: "titlefontnamesize",
          //       label: "",
          //       label_type: "Font Type",
          //       label_size: "Font Size",
          //       type: "fontsize",
          //       values_type: [
          //         { value: "Arial", text: "Arial" },
          //         { value: "Helvetica Neue", text: "Helvetica Neue" },
          //       ],
          //       values_size: [
          //         { value: "10", text: "10" },
          //         { value: "12", text: "12" },
          //         { value: "14", text: "14" },
          //       ],
          //       tab: "Fonts",
          //     },
          //   ],
          //   options: {
          //     actions: [
          //       {
          //         key: "settings",
          //         label: "Settings",
          //         icon: "fa fa fa-cog text-primary",
          //       },
          //       { divider: true },
          //       { key: "small", label: "Small", icon: "fa fa-th text-primary" },
          //       {
          //         key: "large",
          //         label: "Large",
          //         icon: "fa fa-square text-primary",
          //       },
          //       { divider: true },
          //       {
          //         key: "delete",
          //         label: "Delete",
          //         icon: "fa fa-trash text-danger",
          //       },
          //     ],
          //   },
          // },
          // {
          //     moved: false,
          //   id: "0f6085d8-b594-40f0-8e0f-642042af2ee2",
          //   name: "TickZhold",
          //   cols: 12,
          //   md: 12,
          //   lg: 12,
          //   settings: [
          //     {
          //       key: "type",
          //       label: "Chart Type",
          //       type: "radio-group",
          //       buttons: true,
          //       "button-variant": "outline-primary",
          //       values: [{ value: "horizontalbar", text: "Horizontal Bar" }],
          //       value: "horizontalbar",
          //     },
          //     {
          //       key: "server",
          //       label: "Server",
          //       type: "radio-group",
          //       buttons: true,
          //       "button-variant": "outline-primary",
          //       values: [{ value: "LIVE", text: "LIVE" }],
          //       value: "LIVE",
          //     },
          //     {
          //       key: "title",
          //       label: "Title",
          //       type: "radio-group",
          //       buttons: true,
          //       "button-variant": "outline-primary",
          //       values: [
          //         { value: true, text: "On" },
          //         { value: false, text: "Off" },
          //       ],
          //       value: true,
          //       tab: "Annotate",
          //     },
          //     {
          //       key: "titletext",
          //       label: "Title Text",
          //       type: "text",
          //       value: "ETRPStatus",
          //       tab: "Annotate",
          //     },
          //     {
          //       key: "legend",
          //       label: "Legend",
          //       type: "radio-group",
          //       buttons: true,
          //       "button-variant": "outline-primary",
          //       values: [
          //         { value: true, text: "On" },
          //         { value: false, text: "Off" },
          //       ],
          //       value: false,
          //       tab: "Annotate",
          //     },
          //     {
          //       key: "legendposition",
          //       label: "Legend Position",
          //       type: "radio-group",
          //       buttons: true,
          //       "button-variant": "outline-primary",
          //       values: [
          //         { value: "top", text: "Top" },
          //         { value: "bottom", text: "Bottom" },
          //         { value: "left", text: "Left" },
          //         { value: "right", text: "Right" },
          //       ],
          //       value: "bottom",
          //       tab: "Annotate",
          //     },
          //     {
          //       key: "datalabels",
          //       label: "Data Labels",
          //       type: "radio-group",
          //       buttons: true,
          //       "button-variant": "outline-primary",
          //       values: [
          //         { value: true, text: "On" },
          //         { value: false, text: "Off" },
          //       ],
          //       value: false,
          //       tab: "Annotate",
          //     },

          //     {
          //       key: "titlefontnamesize",
          //       label: "",
          //       label_type: "Font Type",
          //       label_size: "Font Size",
          //       type: "fontsize",
          //       values_type: [
          //         { value: "Arial", text: "Arial" },
          //         { value: "Helvetica Neue", text: "Helvetica Neue" },
          //       ],
          //       values_size: [
          //         { value: "10", text: "10" },
          //         { value: "12", text: "12" },
          //         { value: "14", text: "14" },
          //       ],
          //       tab: "Fonts",
          //     },
          //   ],
          //   options: {
          //     actions: [
          //       {
          //         key: "settings",
          //         label: "Settings",
          //         icon: "fa fa fa-cog text-primary",
          //       },
          //       { divider: true },
          //       { key: "small", label: "Small", icon: "fa fa-th text-primary" },
          //       {
          //         key: "large",
          //         label: "Large",
          //         icon: "fa fa-square text-primary",
          //       },
          //       { divider: true },
          //       {
          //         key: "delete",
          //         label: "Delete",
          //         icon: "fa fa-trash text-danger",
          //       },
          //     ],
          //   },
          // },

          // {
          //   moved: false,
          //   id: "0f5085d8-b594-40f0-8e0f-642042af2ee2",
          //   name: "StorePNRStatus",
          //   cols: 12,
          //   md: 6,
          //   lg: 6,
          //   settings: [
          //     {
          //       key: "type",
          //       label: "Chart Type",
          //       type: "radio-group",
          //       buttons: true,
          //       "button-variant": "outline-primary",
          //       values: [{ value: "table", text: "Table" }],
          //       value: "table",
          //     },
          //     {
          //       key: "logfileid",
          //       label: "Log File Id",
          //       type: "radio-group",
          //       buttons: true,
          //       "button-variant": "outline-primary",
          //       values: [{ value: "storepnr_log", text: "storepnr_log" }],
          //       value: "storepnr_log",
          //     },
          //     {
          //       key: "warningfolder",
          //       label: "Warning Folder",
          //       type: "radio-group",
          //       buttons: true,
          //       "button-variant": "outline-primary",
          //       values: [
          //         { value: "storepnr_waiting", text: "storepnr_waiting" },
          //       ],
          //       value: "storepnr_waiting",
          //     },
          //     {
          //       key: "successfolder",
          //       label: "Success Folder",
          //       type: "radio-group",
          //       buttons: true,
          //       "button-variant": "outline-primary",
          //       values: [
          //         { value: "storepnr_processed", text: "storepnr_processed" },
          //       ],
          //       value: "storepnr_processed",
          //     },
          //     {
          //       key: "dangerfolder",
          //       label: "Danger Folder",
          //       type: "radio-group",
          //       buttons: true,
          //       "button-variant": "outline-primary",
          //       values: [{ value: "storepnr_failed", text: "storepnr_failed" }],
          //       value: "storepnr_failed",
          //     },
          //     // {
          //     //   key: "secondaryfolder",
          //     //   label: "Secondary Folder",
          //     //   type: "radio-group",
          //     //   buttons: true,
          //     //   "button-variant": "outline-primary",
          //     //   values: [
          //     //     { value: "storepnr_ignored", text: "storepnr_ignored" },
          //     //   ],
          //     //   value: "storepnr_ignored",
          //     // },
          //     {
          //       key: "title",
          //       label: "Title",
          //       type: "radio-group",
          //       buttons: true,
          //       "button-variant": "outline-primary",
          //       values: [
          //         { value: true, text: "On" },
          //         { value: false, text: "Off" },
          //       ],
          //       value: true,
          //       tab: "Annotate",
          //     },
          //     {
          //       key: "titletext",
          //       label: "Title Text",
          //       type: "text",
          //       value: "ETRPStatus",
          //       tab: "Annotate",
          //     },
          //     {
          //       key: "legend",
          //       label: "Legend",
          //       type: "radio-group",
          //       buttons: true,
          //       "button-variant": "outline-primary",
          //       values: [
          //         { value: true, text: "On" },
          //         { value: false, text: "Off" },
          //       ],
          //       value: false,
          //       tab: "Annotate",
          //     },
          //     {
          //       key: "legendposition",
          //       label: "Legend Position",
          //       type: "radio-group",
          //       buttons: true,
          //       "button-variant": "outline-primary",
          //       values: [
          //         { value: "top", text: "Top" },
          //         { value: "bottom", text: "Bottom" },
          //         { value: "left", text: "Left" },
          //         { value: "right", text: "Right" },
          //       ],
          //       value: "bottom",
          //       tab: "Annotate",
          //     },
          //     {
          //       key: "datalabels",
          //       label: "Data Labels",
          //       type: "radio-group",
          //       buttons: true,
          //       "button-variant": "outline-primary",
          //       values: [
          //         { value: true, text: "On" },
          //         { value: false, text: "Off" },
          //       ],
          //       value: false,
          //       tab: "Annotate",
          //     },

          //     {
          //       key: "titlefontnamesize",
          //       label: "",
          //       label_type: "Font Type",
          //       label_size: "Font Size",
          //       type: "fontsize",
          //       values_type: [
          //         { value: "Arial", text: "Arial" },
          //         { value: "Helvetica Neue", text: "Helvetica Neue" },
          //       ],
          //       values_size: [
          //         { value: "10", text: "10" },
          //         { value: "12", text: "12" },
          //         { value: "14", text: "14" },
          //       ],
          //       tab: "Fonts",
          //     },
          //   ],
          //   options: {
          //     actions: [
          //       {
          //         key: "settings",
          //         label: "Settings",
          //         icon: "fa fa fa-cog text-primary",
          //       },
          //       { divider: true },
          //       { key: "small", label: "Small", icon: "fa fa-th text-primary" },
          //       {
          //         key: "large",
          //         label: "Large",
          //         icon: "fa fa-square text-primary",
          //       },
          //       { divider: true },
          //       {
          //         key: "delete",
          //         label: "Delete",
          //         icon: "fa fa-trash text-danger",
          //       },
          //     ],
          //   },
          // },

          // {
          //   moved: false,
          //   id: "0f6085d8-b594-40f0-8e0f-642042af2ee2",
          //   name: "ETRPStatus",
          //   cols: 12,
          //   md: 6,
          //   lg: 6,
          //   settings: [
          //     {
          //       key: "type",
          //       label: "Chart Type",
          //       type: "radio-group",
          //       buttons: true,
          //       "button-variant": "outline-primary",
          //       values: [{ value: "donut", text: "Donut" }],
          //       value: "donut",
          //     },
          //     {
          //       key: "server",
          //       label: "Server",
          //       type: "radio-group",
          //       buttons: true,
          //       "button-variant": "outline-primary",
          //       values: [
          //         { value: "LIVE", text: "LIVE" },
          //         { value: "DEV", text: "DEV" },
          //         { value: "TP-INETSERVER", text: "TP-INETSERVER" },
          //       ],
          //       value: "LIVE",
          //     },
          //     {
          //       key: "title",
          //       label: "Title",
          //       type: "radio-group",
          //       buttons: true,
          //       "button-variant": "outline-primary",
          //       values: [
          //         { value: true, text: "On" },
          //         { value: false, text: "Off" },
          //       ],
          //       value: true,
          //       tab: "Annotate",
          //     },
          //     {
          //       key: "titletext",
          //       label: "Title Text",
          //       type: "text",
          //       value: "ETRPStatus",
          //       tab: "Annotate",
          //     },
          //     {
          //       key: "legend",
          //       label: "Legend",
          //       type: "radio-group",
          //       buttons: true,
          //       "button-variant": "outline-primary",
          //       values: [
          //         { value: true, text: "On" },
          //         { value: false, text: "Off" },
          //       ],
          //       value: false,
          //       tab: "Annotate",
          //     },
          //     {
          //       key: "legendposition",
          //       label: "Legend Position",
          //       type: "radio-group",
          //       buttons: true,
          //       "button-variant": "outline-primary",
          //       values: [
          //         { value: "top", text: "Top" },
          //         { value: "bottom", text: "Bottom" },
          //         { value: "left", text: "Left" },
          //         { value: "right", text: "Right" },
          //       ],
          //       value: "bottom",
          //       tab: "Annotate",
          //     },
          //     {
          //       key: "datalabels",
          //       label: "Data Labels",
          //       type: "radio-group",
          //       buttons: true,
          //       "button-variant": "outline-primary",
          //       values: [
          //         { value: true, text: "On" },
          //         { value: false, text: "Off" },
          //       ],
          //       value: false,
          //       tab: "Annotate",
          //     },

          //     {
          //       key: "titlefontnamesize",
          //       label: "",
          //       label_type: "Font Type",
          //       label_size: "Font Size",
          //       type: "fontsize",
          //       values_type: [
          //         { value: "Arial", text: "Arial" },
          //         { value: "Helvetica Neue", text: "Helvetica Neue" },
          //       ],
          //       values_size: [
          //         { value: "10", text: "10" },
          //         { value: "12", text: "12" },
          //         { value: "14", text: "14" },
          //       ],
          //       tab: "Fonts",
          //     },
          //   ],
          //   options: {
          //     actions: [
          //       {
          //         key: "settings",
          //         label: "Settings",
          //         icon: "fa fa fa-cog text-primary",
          //       },
          //       { divider: true },
          //       { key: "small", label: "Small", icon: "fa fa-th text-primary" },
          //       {
          //         key: "large",
          //         label: "Large",
          //         icon: "fa fa-square text-primary",
          //       },
          //       { divider: true },
          //       {
          //         key: "delete",
          //         label: "Delete",
          //         icon: "fa fa-trash text-danger",
          //       },
          //     ],
          //   },
          // },
          // {
          //   moved: false,
          //   id: "0f5085d8-b594-40f0-8e0f-642042af2ee2",
          //   name: "ETRPChart",
          //   cols: 12,
          //   md: 3,
          //   lg: 3,
          //   settings: [
          //     {
          //       key: "type",
          //       label: "Chart Type",
          //       type: "radio-group",
          //       buttons: true,
          //       "button-variant": "outline-primary",
          //       values: [{ value: "donut", text: "Donut" }],
          //       value: "donut",
          //     },
          //     {
          //       key: "server",
          //       label: "Server",
          //       type: "radio-group",
          //       buttons: true,
          //       "button-variant": "outline-primary",
          //       values: [
          //         { value: "LIVE", text: "LIVE" },
          //         { value: "DEV", text: "DEV" },
          //         { value: "TP-INETSERVER", text: "TP-INETSERVER" },
          //       ],
          //       value: "LIVE",
          //     },
          //     {
          //       key: "title",
          //       label: "Title",
          //       type: "radio-group",
          //       buttons: true,
          //       "button-variant": "outline-primary",
          //       values: [
          //         { value: true, text: "On" },
          //         { value: false, text: "Off" },
          //       ],
          //       value: true,
          //       tab: "Annotate",
          //     },
          //     {
          //       key: "titletext",
          //       label: "Title Text",
          //       type: "text",
          //       value: "ETRPStatus",
          //       tab: "Annotate",
          //     },
          //     {
          //       key: "legend",
          //       label: "Legend",
          //       type: "radio-group",
          //       buttons: true,
          //       "button-variant": "outline-primary",
          //       values: [
          //         { value: true, text: "On" },
          //         { value: false, text: "Off" },
          //       ],
          //       value: false,
          //       tab: "Annotate",
          //     },
          //     {
          //       key: "legendposition",
          //       label: "Legend Position",
          //       type: "radio-group",
          //       buttons: true,
          //       "button-variant": "outline-primary",
          //       values: [
          //         { value: "top", text: "Top" },
          //         { value: "bottom", text: "Bottom" },
          //         { value: "left", text: "Left" },
          //         { value: "right", text: "Right" },
          //       ],
          //       value: "bottom",
          //       tab: "Annotate",
          //     },
          //     {
          //       key: "datalabels",
          //       label: "Data Labels",
          //       type: "radio-group",
          //       buttons: true,
          //       "button-variant": "outline-primary",
          //       values: [
          //         { value: true, text: "On" },
          //         { value: false, text: "Off" },
          //       ],
          //       value: false,
          //       tab: "Annotate",
          //     },

          //     {
          //       key: "titlefontnamesize",
          //       label: "",
          //       label_type: "Font Type",
          //       label_size: "Font Size",
          //       type: "fontsize",
          //       values_type: [
          //         { value: "Arial", text: "Arial" },
          //         { value: "Helvetica Neue", text: "Helvetica Neue" },
          //       ],
          //       values_size: [
          //         { value: "10", text: "10" },
          //         { value: "12", text: "12" },
          //         { value: "14", text: "14" },
          //       ],
          //       tab: "Fonts",
          //     },
          //   ],
          //   options: {
          //     actions: [
          //       {
          //         key: "settings",
          //         label: "Settings",
          //         icon: "fa fa fa-cog text-primary",
          //       },
          //       { divider: true },
          //       { key: "small", label: "Small", icon: "fa fa-th text-primary" },
          //       {
          //         key: "large",
          //         label: "Large",
          //         icon: "fa fa-square text-primary",
          //       },
          //       { divider: true },
          //       {
          //         key: "delete",
          //         label: "Delete",
          //         icon: "fa fa-trash text-danger",
          //       },
          //     ],
          //   },
          // },
        ],
      },
      reponsiveGrid: {
        layouts: {
          md: [
            { x: 0, y: 0, w: 5, h: 6, i: "1" },
            { x: 5, y: 0, w: 5, h: 6, i: "2" },
            // { x: 0, y: 25, w: 5, h: 6, i: "3" },
            // { x: 5, y: 25, w: 3, h: 6, i: "4" },
          ],
        },
        breakpoint: "md",
        components: {
          1: { i: "1", component: "NLPost", defaultSize: 2 },
        },
        cols: 10,
        breakpoints: { lg: 1200, md: 996, sm: 768, xs: 480, xxs: 0 },
        colsAll: { lg: 10, md: 8, sm: 6, xs: 4, xxs: 2 },
        isDraggable: true,
        isResizable: true,
      },
      selectedComponent: null,
      search: null,
    };
  },
  watch: {
    refresh: {
      // immediate: true,
      handler(newVal, oldVal) {
        if (newVal) {
          this.refresh_time = new Date();
        }
      },
    },
  },
  computed: {
    ...mapGetters(["window", "user"]),
  },
  methods: {
    async loadData() {
      this.busy = true;

      // OVERIDE THE DATA
      this.layout_grid = this.defaultOptions.layout_grid;

      this.busy = false;
      this.layout_autorefresh();
    },
    async saveData() {
      console.log("saveData", this.layout);
      this.busy = true;
      
      this.busy = false;
      this.layout_edit = false;
    },
    async saveTile(t) {
      console.log("saveTile", this.tile_selected, t);
      this.layout_grid[this.tile_selected] = t;
      this.refresh = true;
      this.tile_settings = false;
    },
    invoke_action(s, r) {
      console.log("invoke action", s, r);
      if (s.key) {
        console.log(s.key);
        switch (s.key) {
          case "settings":
            this.tile_settings = true;
            this.$root.$emit("bv::toggle::collapse", "tilesettings");
            break;
        }
      }
    },
    async layout_refresh() {
      this.refresh = true;
      await this.loadData();
    },
    layout_autorefresh() {
      this.refresh_time = new Date();
      this.refresh = true;
      clearInterval(this.timer_time);
      clearInterval(this.timer_refresh);
      if (this.refresh_at > 0) {
        this.timer_refresh = setInterval(() => {
          this.layout_autorefresh();
        }, 100000);
        if (this.refresh_at > 0) {
          this.timer_time = setInterval(() => {
            this.layout_timeago();
          }, 10000);
        }
        this.layout_timeago();
      }
    },
    layout_timeago() {
      this.refresh_timeago = this.$options.filters.formatTimeago(
        this.refresh_time
      );
    },
  },
};
</script>

<style></style>
